import { injectService } from '@/inversify.config';
import { I18nService } from '@/services/i18n-service';
import _ from 'lodash';
// @ts-ignore
import { EmailInput as PtEmailInput } from 'patsnap-biz';
import { getSharedCompanyEmailApi, getSuggestionEmailApi } from '@cores/apis/workspace_api/workspace';
import { SpaceService } from '@/domains/detail/space/types/space-service.interface';
export class CustomEmailInputService extends PtEmailInput.EmailInputService {
    constructor(_options) {
        super();
        this._options = _options;
        this._i18nService = injectService(I18nService);
        this._spaceService = injectService(SpaceService);
        this.initSelectedEmail = '';
        this.placeholder = this._options.placeholder;
        this.nodataLabel = this._i18nService.t('shareUserOrGroup.user.noData');
        this._key = _.uniqueId('emailInputService_');
        this.companyMode = true;
        this.isAlwaysShowOnFocus = this._options.autoFocus;
    }
    setSelectedEmail(newSelected, ...args) {
        super.setSelectedEmail(newSelected, ...args);
        this._options.postSelectCallback(newSelected.length ? newSelected[0] : undefined);
    }
    getEmailList(keywords) {
        // 优先使用传入的参数，没有的话从 SpaceService 获取
        let isPublicSpace = this._options.isPublicSpace;
        if (isPublicSpace === undefined) {
            const spaceInfo = this._spaceService.spaceInfo;
            isPublicSpace = spaceInfo?.is_public_space || false;
        }
        let nodataTips = '';
        if (isPublicSpace) {
            nodataTips = this._i18nService.t('CopyCustomFieldDialog.errors.publicAccountErrorSelfSpace');
        }
        else {
            nodataTips = this._i18nService.t('CopyCustomFieldDialog.errors.outAccountErrorSelfSpace');
        }
        this.nodataLabel = nodataTips;
        return this._autoCompleteApi(keywords)
            .then((res) => {
            if (res.match_all_user_count) {
                // 这里是搜索后有匹配但权限不够的情况
                this.nodataLabel = nodataTips;
            }
            return res.records;
        });
    }
    getDefaultList() {
        this.nodataLabel = this._i18nService.t('shareUserOrGroup.user.noData');
        return this._suggestionApi();
    }
    _autoCompleteApi(keyword) {
        const with_tenant = this._options.withTenant === undefined
            ? true
            : this._options.withTenant;
        return getSuggestionEmailApi({
            name: keyword,
            cache: false,
            with_tenant,
        })
            .then((res) => {
            return res || {};
        });
    }
    _suggestionApi() {
        return getSharedCompanyEmailApi({ cache: false })
            .then(({ user_infos, user_total }) => {
            this._options.onSuggestionLoad?.({ total: user_total });
            return user_infos;
        });
    }
}
